import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Spinner from '../Spinner';
import './OverlaySpinner.scss';
var OverlaySpinner = function OverlaySpinner(_ref) {
  var animationTimeout = _ref.animationTimeout,
    description = _ref.description,
    show = _ref.show,
    text = _ref.text;
  return /*#__PURE__*/React.createElement(TransitionGroup, {
    className: "overlay"
  }, show && /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: "overlay",
    className: "overlay-spinner",
    timeout: {
      enter: animationTimeout,
      exit: animationTimeout
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "overlay-spinner__text-container"
  }, /*#__PURE__*/React.createElement("p", {
    className: "overlay-spinner__text"
  }, text), description && /*#__PURE__*/React.createElement("p", {
    className: "overlay-spinner__description"
  }, description)), /*#__PURE__*/React.createElement("div", {
    className: "overlay-spinner__options"
  }, /*#__PURE__*/React.createElement(Spinner, null)))));
};
OverlaySpinner.propTypes = {
  animationTimeout: PropTypes.number,
  description: PropTypes.string,
  show: PropTypes.bool,
  text: PropTypes.string
};
OverlaySpinner.defaultProps = {
  animationTimeout: 500,
  description: '',
  show: false,
  text: 'Submitting...'
};
export default OverlaySpinner;
//# sourceMappingURL=OverlaySpinner.js.map